(function(){
  function fix(root){
    root.querySelectorAll('.sale-badge').forEach(function(e){
      var t=(e.textContent||'').trim();
      var m=t.match(/(\d+)\s*%/);
      if(m && t.charAt(0)!=='-'){e.textContent='-'+m[1]+'%';}
    });
    root.querySelectorAll('.price__saved .price-item').forEach(function(e){
      if(e.children.length===0){
        var t=e.textContent;
        if(/^\s*Salva\b/i.test(t)){e.textContent=t.replace(/^\s*Salva\s*/i,'Risparmi ');}
      }
    });
  }
  function run(){fix(document);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
  new MutationObserver(function(){run();}).observe(document.documentElement,{childList:true,subtree:true,characterData:true});
})();
